import React, { ReactNode } from 'react';
import { Flex, Grid, GridItem, useMediaQuery } from '@chakra-ui/react';

import SidebarContent from '@/components/0-reusable-components/navigation/admin-navbar/sidebar';
import SideNavbar from '@/components/0-reusable-components/navigation/admin-navbar/sidebar/side-navbar';
import { breakpointMap } from '@/styles/ui.theme';

export interface IProps {
  children: ReactNode;
  showBackButton?: boolean;
  noPadding?: boolean;
}

const SecretariaLayoutB = ({ children, noPadding }: IProps): React.ReactElement => {
  const [isExtraLargeViewport] = useMediaQuery(
    `(min-width: ${breakpointMap.extraLargeBreakpoint}px)`,
  );

  const NAVBAR_HEIGHT = 65;
  const LAYOUT_PADDING = noPadding ? 0 : 32;
  const COLUMNS = isExtraLargeViewport ? 5 : 4;
  const MENU_WIDTH_IN_COLUMNS = 1;

  return (
    <>
      <SideNavbar />
      <Grid
        minH={`calc(100vh - ${NAVBAR_HEIGHT}px)`}
        templateRows='repeat(1, 1fr)'
        templateColumns={`repeat(${COLUMNS}, 1fr)`}
      >
        <GridItem rowSpan={1} colSpan={MENU_WIDTH_IN_COLUMNS}>
          <SidebarContent />
        </GridItem>
        <GridItem rowSpan={1} colSpan={COLUMNS - MENU_WIDTH_IN_COLUMNS}>
          <Flex
            p={`${LAYOUT_PADDING}px`}
            minH={`calc(100vh - ${NAVBAR_HEIGHT}px)`}
            direction='column'
            align='center'
            justify='flex-start'
          >
            {children}
          </Flex>
        </GridItem>
      </Grid>
    </>
  );
};

export default SecretariaLayoutB;
